/*global define*/
define('core/services/UserService',['angular'], function(angular) {
    'use strict';
    return angular.module('dnaApp').service('UserService', ['$q', '$log', '$http', '$rootScope', 'CacheFactory', function($q, $log, $http, $rootScope, CacheFactory) {
        var userInfoCache = CacheFactory('userInfoCache', { maxAge: 91540000000, storageMode: 'localStorage' }); // Keep items for 3 years
        var userProfileCache = CacheFactory('userProfileCache', { maxAge: 30000, storageMode: 'localStorage' }); // short term for repeat requests

        /**
         * @class UserService
         * @desc Service that provides access to user information
         */
        return {
            preTncPath: '',

            getUserMiniProfile: function () {
                var deferred = $q.defer();
                var url = '/secure/user';
                $http.get(url, {cache: userProfileCache}).success(function(data) {
                    deferred.resolve(data);
                }).error(function (data) {
                    deferred.reject(data);
                });
                return deferred.promise;
            },

            acceptTerms: function() {
                var UserId = $rootScope.Cookies.find('LAU') || $rootScope.dna.app.mainTestGuid;
                var deferred = $q.defer();
                var url = '/secure/userTnc';

                var putData = {
                    'tandCTimeStamp': Date.now()
                };
                $http.put(url, putData).success(function() {
                    userInfoCache.put(url + UserId, putData);
                    deferred.resolve(putData);
                }).error(function(data) {
                    userInfoCache.remove(url + UserId);
                    deferred.reject(data);
                });
                return deferred.promise;
            },

            acceptedTerms: function() {
                var UserId = $rootScope.Cookies.find('LAU') || $rootScope.dna.app.mainTestGuid;
                var deferred = $q.defer();
                var url = '/secure/userTnc',
                    data = userInfoCache.get(url + UserId);
                if (data) {
                    deferred.resolve(data);
                } else {
                    $http.get(url).success(function (data) {
                        if (data && data.tandCTimeStamp) {
                            userInfoCache.put(url + UserId, data);
                        }
                        deferred.resolve(data);
                    }).error(function (data, status, headers, config) {
                        deferred.reject({ status: status, config: config });
                    });
                }
                return deferred.promise;
            },

            deleteProfilePhoto: function() {
                var deferred = $q.defer();
                var url = '/secure/profileImage';
                $http({
                    url: url,
                    method: 'DELETE'
                }).success(function(data) {
                    deferred.resolve(data);
                }).error(function(data) {
                    deferred.reject(data);
                });
                return deferred.promise;
            }
        };
    }]);
});

